module.exports = __webpack_public_path__ + "img/as.b4518f6b.svg";